import { PrivacyPolicy } from "@/pages/privacy-policy/PrivacyPolicy";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/privacypolicy")({
  component: PrivacyPolicy,
});
